import { useSanitizeData } from '../../Common/hooks/useSanitizeData';
import { number } from '../../../Common/Util/number';
import TableComponent from '../../../Common/Charts/TableCharts';
import { useDeathCauseChartsDataContext } from './hooks/useDeathCauseChartsDataContext';

export const DeathCauseMonth = () => {
    const { chartData } = useDeathCauseChartsDataContext();

      const monthNames = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Maio',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    const tableColumns = [
            {
                key: 'ano_competencia',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'mes_competencia',
                header: 'Mês',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'causa_mortis',
                header: 'Causa da Morte',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.deathCauseMonth || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.causas_mortis?.map((deathCause) => ({
            ...deathCause,
            ano_competencia: itemAno.ano_competencia,
            mes_competencia: monthNames[itemAno.mes_competencia - 1]
        }));
    });
    
    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Causas de Morte - Mensal"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};